/**
 * Created by jonas on 2019-08-21.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {Linear, Power2, Power4, TimelineLite, TweenLite} from "gsap";
import {IWinRatioConfig, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {SALayerConfig} from "../../config/SALayerConfig";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SpacierArcadeGameAssets} from "../SpacierArcadeGameAssets";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";

export class WinTextView extends BaseView {
    private _winText:PIXI.Sprite;
    private _winTextContainer:PIXI.Container;
    private _layer:ScalableLayer;
    private _currentSound:string ="";
    private _bigWinSpine:PIXI.spine.Spine;
    private _bigWinShineSpine:PIXI.spine.Spine;

    constructor() {
        super();
        this._layer = StageManager.getLayer(SALayerConfig.BIG_WIN.name);
    }


    protected initAnimations():void {
        this._bigWinSpine = new PIXI.spine.Spine(GameResources.getSpineAsset(SpacierArcadeGameAssets.BIG_WIN));
        this._bigWinSpine.autoUpdate = true;
        this._bigWinSpine.position.set(GameConfig.instance.REEL_AREA_WIDTH * 0.5 + GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_HEIGHT * 0.54 +  GameConfig.instance.REEL_AREA_POS_Y);
        this.addChild(this._bigWinSpine);



        this._winText = new PIXI.Sprite(GameResources.getTextures("big_win")[0]);
        this._winText.anchor.set(0.5, 0.5);

        const scale = 700 / this._winText.width;
        this._winText.scale.set(0.9);



        this._winTextContainer = new PIXI.Container();
        this._winTextContainer.position.set(360, 230);

        this._winTextContainer.addChild(this._winText);
        this.addChild(this._winTextContainer);

        this._bigWinShineSpine = new PIXI.spine.Spine(GameResources.getSpineAsset(SpacierArcadeGameAssets.BIG_WIN_SHINE));
        this._bigWinShineSpine.position.set(GameConfig.instance.REEL_AREA_WIDTH * 0.5 + GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_HEIGHT * 0.24 +  GameConfig.instance.REEL_AREA_POS_Y);
        this.addChild(this._bigWinShineSpine);
    }


    public getStartAnimation(config:IWinRatioConfig):TimelineLite{
        const tl:TimelineLite = new TimelineLite();

        tl.add(() => {
            this.updateText(config);
            this._winTextContainer.scale.set(0.5,0.5);
            // this._winTextContainer.alpha = 0.5;
            this._layer.addChild(this)
        });

        tl.add(() => {
            this.playBigWinAnimation(config);
            TweenLite.fromTo(this._winTextContainer.scale, 0.5, {x: 1.7, y: 1.7}, {x: 1, y: 1, ease: Power4.easeIn});
        });

        return tl;
    }

    private playBigWinAnimation(config:IWinRatioConfig):TimelineLite{

        let animName:string = config.type === WinRatioType.BIG_WIN ? "big_win_lvl_1" : "big_win_lvl_2";
        let anim:TimelineLite = new TimelineLite();
        anim.add([
            TweenLite.to(this._bigWinSpine, 0, {alpha : 1}),
            TweenLite.to(this._bigWinShineSpine, 0, {alpha : 1}),
            new SpineTween(this._bigWinSpine, 0, "movement", -1),
            new SpineTween(this._bigWinSpine, 1, animName, -1),
            new SpineTween(this._bigWinShineSpine, 0, "big_win_shine_loop", -1),
            new SpineTween(this._bigWinSpine, 2, "pump")
        ]);
        return anim;
    }

    public getEndAnimation(config:IWinRatioConfig):TimelineLite{
        const tl:TimelineLite = new TimelineLite();

        //Hide prev text
        // tl.add([
        //     new TweenLite(this._winTextContainer, 2.0, {alpha : 0.5, ease : Linear.easeNone}),
        //     new TweenLite(this._winTextContainer.scale, 2.0, {x : 0.5, y : 0.5, ease : Power2.easeInOut}),
        //     new TweenMax(this._winTextContainer, 2.0, {rotation : 0.2, ease : Elastic.easeIn.config(1, 0.05)})
        // ]);

        tl.add([
            TweenLite.fromTo(this._winTextContainer.scale, 0.5, {x : 1.7, y : 1.7}, {x : 1, y : 1, ease : Power4.easeIn})
        ]);

        return tl;
    }

    private fadeOutBigWinSpine():void{
        const timeline:TimelineLite = new TimelineLite({onComplete: () => {
                this._bigWinSpine.state.clearTracks();
                this._bigWinShineSpine.state.clearTracks();
                this._bigWinSpine.skeleton.setToSetupPose();
                this._bigWinShineSpine.skeleton.setToSetupPose();
            }});
        timeline.add(TweenLite.to(this._bigWinSpine, 1, {alpha : 0}));
        timeline.add(TweenLite.to(this._bigWinShineSpine, 1, {alpha : 0}));

    }




    public abort(config:IWinRatioConfig):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        if(config.text == undefined || config.text == "") {
            return tl;
        }
        tl.add(() => {
            this.updateText(config);
            this._layer.addChild(this);
            this._winTextContainer.scale.set(1, 1);
            this._winTextContainer.rotation = 0;
            this._winTextContainer.alpha = 1;
        }, 0.001);
        return tl;
    }

    public end(config:IWinRatioConfig, displayDuration:number, fadeOutDuration:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            this._currentSound = "";
        });
        // tl.add(this.getStartAnimation(config));
        tl.add(() => this.fadeOutBigWinSpine());
        tl.add(() => this.fadeAndRemove(fadeOutDuration), displayDuration);
        tl.add(() => this.cleanup());
        return tl;
    }


    private updateText(config:IWinRatioConfig) {
        let textureImg:string = "big_win";
        this._winTextContainer.position.set(360, 230);
        switch(config.text){
            case "Massive win":
                this._winTextContainer.position.set(360, 220);
                textureImg = "massive_win";
                break;
            case "Big bang":
                textureImg = "big_bang";
                break;
        }
        this._winText.texture = GameResources.getTextures(textureImg)[0];
    }

    private fadeAndRemove(duration:number) {
        const tl:TimelineLite = new TimelineLite();

        tl.add([
            new TweenLite(this._winTextContainer.scale, duration, {x : 0, y : 0, ease : Power2.easeIn}),
            new TweenLite(this._winTextContainer, duration, {alpha : 0, ease : Linear.easeNone})
        ]);
        tl.add(() => {
            this._layer.removeChild(this);
            this._winTextContainer.alpha = 1;
        });
        return tl;
    }

    private cleanup() {

    }
}